module.exports = __webpack_public_path__ + "img/pdf1.ce652b2c.jpg";